import { Component, OnInit, Input } from '@angular/core';
import { StorageManagerService } from '../../shared/services/index';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';

@Component({
  selector: 'app-submission-device-marketing-eu',
  templateUrl: './submission-device-marketing-eu.component.html',
  styleUrls: ['./submission-device-marketing-eu.component.css']
})
export class SubmissionDeviceMarketingEuComponent extends BaseAccordionComponent implements OnInit {

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {

    super(fb, storage);
   }

  ngOnInit() {
    var data = this.storage.read('sh-item');
    this.applicableRegulation = data?.applicableLegislation;
    this.dataScope = this.storage.read('dataScope');

    this.initializeMainForm();

    this.patchForms();
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({
      deviceStatus: ['', { validators: [] }],
      notIntendedForEu: ['', { validators: [] }],
      memberStateForDevicePlacementInEu: ['', { validators: [] }],
      deviceRecallScope: ['', { validators: [] }],
      membersAvailForm: this.fb.array([this.addMemberAvailForm()]),
      subStatusForm: this.fb.array([this.addSubStatusForm()]),
      recallForm: this.fb.array([this.addRecallForm()]),
      commercialDistributionEndDate: ['', { validators: [] }],
      reasonForDeviceDiscontinuation: ['', { validators: [] }],
      customerServiceCenterName: ['', { validators: [] }],
      customerServiceCenterPhone: ['', { validators: [] }],
      medicalInsuranceCode: ['', { validators: [] }],
      healthBenefitCodesForm: this.fb.array([this.addHealthBenefitCodesForm()]),
      eligibleForHealthCareBenefitsOrReimbursement: ['', { validators: [] }],
      reasonForNotProvidingHealthCareBenefitCode: ['', { validators: [] }],
      newDevice: ['', { validators: [] }]
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
  });
  }

  get healthBenefitCodesForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('healthBenefitCodesForm');
  }

  get membersAvailForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('membersAvailForm');
  }

  get subStatusForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('subStatusForm');
  }

  get recallForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('recallForm');
  }

  addHealthBenefitCodesForm(): any {
    return this.fb.group({
      value: ['', { validators: [] }]
    });
  }

  addSubStatusForm(): FormGroup {

      return this.fb.group({
          subStatusValue: ['', { validators: [] }],
          subStatusStartDate: ['', { validators: [] }],
          subStatusEndDate: ['', { validators: [] }]
      });
  }

  addRecallForm(): FormGroup {

    return this.fb.group({
      value: ['', { validators: [] }],
      languageQualifier: ['', { validators: [] }]
    });
  }

  addMemberAvailForm(): FormGroup {

    return this.fb.group({
      memberStateValue: ['', { validators: [] }],
      startDate: ['', { validators: [] }],
      endDate: ['', { validators: [] }]
    });
  }

  patchForms() {

    this.deviceForm.patchValue({

      deviceStatus: this.displayItemData('Device Status'),
      notIntendedForEu: this.displayItemData('Not intended for being placed on the EU market?'),
      deviceRecallScope: this.displayItemData('Device Recall Scope'),
      memberStateForDevicePlacementInEu: this.displayItemData('Member State Where Device is Placed on the EU Market'),
      commercialDistributionEndDate: this.displayItemData('Commercial Distribution End Date'),
      reasonForDeviceDiscontinuation: this.displayItemData('Reason for Device Discontinuation'),
      customerServiceCenterName: this.displayItemData('Customer Service Center Name'),
      customerServiceCenterPhone: this.displayItemData('Customer Service Center Phone Number'),
      medicalInsuranceCode: this.displayItemData('Medical Insurance Code'),
      eligibleForHealthCareBenefitsOrReimbursement: this.displayItemData('Eligible for Health Care Benefit or Reimbursement?'),
      reasonForNotProvidingHealthCareBenefitCode: this.displayItemData('Reason for Not Providing Health Care Benefit Code'),
      newDevice: this.displayItemData('New Device?')
    });

    this.deviceForm.setControl('membersAvailForm', this.setMemberAvailForm());
    this.deviceForm.setControl('subStatusForm', this.setSubStatusForm());
    this.deviceForm.setControl('recallForm', this.setRecallForm());
    this.deviceForm.setControl('healthBenefitCodesForm', this.setHealthBenefitCodesForm());
  }
  setHealthBenefitCodesForm(): FormArray {

    const formArray = new FormArray([]);

    let codes: any;

    codes = this.displayItemData('Health Care Benefit Code(s)');

    if (codes && codes.length) {
      codes.forEach(c => {

          formArray.push(

                this.fb.group({
                  value: c[(this.getMapInnerPathName('Health Care Benefit Code Value'))[0]]
                })
            );
        });
    }

    return formArray;
  }

  setMemberAvailForm(): FormArray {

    const formArray = new FormArray([]);

    let members: any;

    members = this.displayItemData('Member State(s) Where Device is Made Available');

    if (members && members.length > 0) {
      members.forEach((c, i) => {

          formArray.push(

                this.fb.group({
                  memberStateValue: c[(this.getMapInnerPathName('Member State Value'))[0]],
                  startDate: c[(this.getMapInnerPathName('Availability Start Date'))[0]],
                  endDate: c[(this.getMapInnerPathName('Availability End Date'))[0]]
                })
            );
        });
    }

    return formArray;
  }

  setSubStatusForm(): FormArray {

    const formArray = new FormArray([]);

    let status: any;

    status = this.displayItemData('Device SubStatus');

      if (status) {
          status.forEach((c, i) => {
      formArray.push(

        this.fb.group({
            subStatusValue: c[(this.getMapInnerPathName('Device SubStatus Value'))[0]],
            subStatusStartDate: c[(this.getMapInnerPathName('Device SubStatus Start Date'))[0]],
            subStatusEndDate: c[(this.getMapInnerPathName('Device SubStatus End Date'))[0]]
        })

              );
          });
    }
    return formArray;
  }

  setRecallForm(): FormArray {

    const formArray = new FormArray([]);

    let recalls: any;

    recalls = this.displayItemData('Device Recall Precision');

    if (recalls && recalls.length > 0) {
      recalls.forEach((c, i) => {

          formArray.push(

                this.fb.group({
                  value: c[(this.getMapInnerPathName('Device Recall Precision Value'))[0]],
                  languageQualifier: c[(this.getMapInnerPathName('Device Recall Precision Language'))[0]]
                })
            );
        });
    }

    return formArray;
  }
}

